/**
 * Represents a flow which allows the customer to modify their account.
 *
 * This is used in logic such as PrepaySelectManager which needs to behave differently for different flows.
 */
export enum AccountModificationFlowId {
  /** Base payflow */
  Purchase = 'purchase',
  /** "Change payment plan", initiated by customers from the "Billing" tab on the settings page. */
  ChangePaymentPlan = 'change-payment-plan',
}
